export default "__VITE_ASSET__BritJqq2__"